import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-black/25" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-center justify-center p-4 text-center" }
const _hoisted_4 = { class: "mt-2 py-6 flex flex-col space-y-6 justify-center items-start" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-6 w-full" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-brand-text" }, "Title", -1)
const _hoisted_8 = {
  key: 1,
  class: "flex flex-row space-x-4 justify-center w-full"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Save", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Cancel", -1)
const _hoisted_12 = [
  _hoisted_11
]

import LoadingComponent from "@/components/LoadingComponent.vue";

import { QuillEditor } from '@vueup/vue-quill'
import '@/styles/vue-quill.snow.css';

import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from "@headlessui/vue";
import {ref} from "vue";
import {doc, setDoc, Timestamp} from "firebase/firestore";
import {db} from "@/firebase";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddPolicyDialog',
  props: {
    onClose: { type: Function },
    policy: {}
  },
  setup(__props: any) {

const props = __props;


const policy = ref(props.policy || '')
const closeDialog = () => {
  props.onClose?.()
}

const loading = ref(false)

const localPolicy = ref(policy)
const myEditor = ref<any>(null)

const savePolicy = async () => {
  localPolicy.value = myEditor.value?.getHTML() || ''
  if (localPolicy.value === '') {
    alert('Please fill all fields')
    return
  }
  try {
    loading.value = true
    await setDoc(doc(db, 'terms-policy', 'policy'), {
      content: localPolicy.value,
      updated_at: Timestamp.now()
    })
    loading.value = false
    alert('Policy updated successfully')
    closeDialog()
  } catch (e) {
    loading.value = false
    console.error(e);
    alert('Failed to update')
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: true
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-10",
        onClose: closeDialog
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "duration-300 ease-out",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "duration-200 ease-in",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "w-full min-w-3xl transform overflow-hidden rounded-2xl bg-brand-card p-6 text-left align-middle shadow-xl transition-all" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogTitle), {
                        as: "h3",
                        class: "text-lg font-bold leading-6 text-center text-brand-text"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString('Edit Privacy Policy'))
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _hoisted_7,
                            _createVNode(_unref(QuillEditor), {
                              ref_key: "myEditor",
                              ref: myEditor,
                              theme: "snow",
                              content: localPolicy.value,
                              placeholder: "Enter Policy here...",
                              "content-type": "html",
                              modelValue: localPolicy.value,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localPolicy).value = $event))
                            }, null, 8, ["content", "modelValue"])
                          ]),
                          (loading.value)
                            ? (_openBlock(), _createBlock(LoadingComponent, { key: 0 }))
                            : _createCommentVNode("", true),
                          (!loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("button", {
                                  onClick: _cache[1] || (_cache[1] = () => savePolicy()),
                                  class: "bg-brand-secondary justify-center w-32 text-center text-white font-bold space-x-2 px-6 py-2 rounded-md flex flex-row"
                                }, _hoisted_10),
                                _createElementVNode("button", {
                                  onClick: closeDialog,
                                  class: "bg-red-500 justify-center w-32 text-center text-white font-bold space-x-2 px-6 py-2 rounded-md flex flex-row"
                                }, _hoisted_12)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})